import { render, staticRenderFns } from "./fourthCard.vue?vue&type=template&id=4bb2a377&scoped=true"
import script from "./fourthCard.vue?vue&type=script&lang=js"
export * from "./fourthCard.vue?vue&type=script&lang=js"
import style0 from "./fourthCard.vue?vue&type=style&index=0&id=4bb2a377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2a377",
  null
  
)

export default component.exports